import _get from 'lodash/get';

import { localStore } from 'utils';

export default function getRulesLabelMap() {
  const masterData = JSON.parse(localStore.get('dictionary'));
  return _get(masterData, 'automationRuleActionChoices', {});
}
